export default function validateLogin(values) {
  let errors = {};
  if (!values.username || values.username === "") {
    errors.username = 'Username is required';
  }
  if (!values.password) {
    errors.password = 'Password is required';
  }

  return errors;
};

export function validateForgotPassword(values) {
  let errors = {};
  if (!values.email) {
    errors.username = 'Email is required';
  }

  return errors;
}

export function validateDepartmentSubmit(values) {
  let errors = {};

  if (!values.name) {
    errors.name = 'Department name is required';
  }
  return errors;
}

export function validateMachineSubmit(values) {
  let errors = {};

  if (!values.name) {
    errors.name = 'Machine name is required';
  }

  if (!values.circumference) {
    errors.circumference = 'Circumference is required';
  }

  if (!values.kitId) {
    errors.kitId = 'Kit id is required';
  }

  if(!values.type){
    errors.type = "Department is required";
  }

  if(!values.id){
    errors.id = "Machine id is required";
  }

  return errors;
}


export function validateResetPassword(values) {
  let errors = {};
  if (!values.password) {
    errors.password = 'Password is required';
  } else if (values.password.length < 8) {
    errors.password = 'Password must be 8 or more characters';
  }
  if (!values.confirmPassword) {
    errors.confirmPassword = 'Confirm Password is required';
  }
  if (values.password !== values.confirmPassword) {
    errors.match = 'Password Should match';
  }

  return errors;
}


export function validateSignUp(values) {
  let errors = {};
  if (!values.username) {
    errors.username = 'Username is required';
  }
  if (!values.password) {
    errors.password = 'Password is required';
  } else if (values.password.length < 8) {
    errors.password = 'Password must be 8 or more characters';
  }
  if (!values.confirmPassword) {
    errors.confirmPassword = 'Confirm Password is required';
  } else if (values.password !== values.confirmPassword) {
    errors.confirmPassword = 'Password Should match';
  }


  return errors;
}